import React from "react";
import { Typography, Link } from "@mui/material";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "black",
        color: "#fff",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <Typography variant="body1" sx={{ color: "#AFEEEE" }}>
        © 2024 TEH GRET HULVING. All rights reserved.
      </Typography>
      <Typography
        variant="body2"
        style={{ marginTop: "10px", color: "#AFEEEE" }}
      >
        Made with ❤️
        <br></br>
        This token is simply a meme coin with no intrinsic value or expectation
        of financial return.
      </Typography>
    </footer>
  );
};

export default Footer;
